export * from 'components/details/utils/clickify'
